import React from "react";
import { useViewport } from 'components/general/useViewPort';
import { findArray } from 'helpers/utils';
import Label from "components/general/Label";


export const TableExpanded = React.memo((props) => {
    const { breakPoint } = useViewport();

    let firstRoutine = findArray(props.row.extendedResults, { er_code: ['ROUTINE'], er_pos: ['1'] })
    let secondRoutine = findArray(props.row.extendedResults, { er_code: ['ROUTINE'], er_pos: ['2'] })

    let showQualMark = props.showQualMark

    //DURATION
    let firstRoutineDuration = findArray(firstRoutine?.extensions, { ere_code: ['DIFFICULTY'] })?.ere_value
    let secondRoutineDuration = findArray(secondRoutine?.extensions, { ere_code: ['DIFFICULTY'] })?.ere_value

    //EXECUTION
    let firstRoutineExecution = findArray(firstRoutine?.extensions, { ere_code: ['EXECUTION'] })?.ere_value
    let secondRoutineExecution = findArray(secondRoutine?.extensions, { ere_code: ['EXECUTION'] })?.ere_value

    //TIME_OF_FLIGHT
    let firstRoutineTime = findArray(firstRoutine?.extensions, { ere_code: ['TIME'] })?.ere_value
    let secondRoutineTime = findArray(secondRoutine?.extensions, { ere_code: ['TIME'] })?.ere_value

    //HOR_DISPLACE
    let firstRoutineHorDisplace = findArray(firstRoutine?.extensions, { ere_code: ['HOR_DISPLACE'] })?.ere_value
    let secondRoutineHorDisplace = findArray(secondRoutine?.extensions, { ere_code: ['HOR_DISPLACE'] })?.ere_value

    //PENALTIES
    let firstRoutinePenalty = findArray(firstRoutine?.extensions, { ere_code: ['PENALTY'] })?.ere_value
    let secondRoutinePenalty = findArray(secondRoutine?.extensions, { ere_code: ['PENALTY'] })?.ere_value

    let hasPenalty = findArray(firstRoutine?.extensions, { ere_code: ['PENALTY'] }) || findArray(secondRoutine?.extensions, { ere_code: ['PENALTY'] })

    if (breakPoint === 'sm' || breakPoint === 'xs') {
        return (
            <>
                <table className="table table-detail">
                    <thead>
                        <tr>
                            <th scope="col"><Label data={'HeaderScore'} /></th>
                            <th scope="col" className="text-end"><Label data={`HeaderExercise1`} sport='GTR' /></th>
                            <th scope="col" className="text-end"><Label data={`HeaderExercise2`} sport='GTR' /></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='w-60'><Label data={'HeaderDifficulty'} /></td>
                            <td className="w-20 text-end">{firstRoutineDuration}</td>
                            <td className="w-20 text-end">{secondRoutineDuration}</td>
                        </tr>
                        <tr>
                            <td className='w-60'><Label data={'HeaderExecution'} /></td>
                            <td className="w-20 text-end">{firstRoutineExecution}</td>
                            <td className="w-20 text-end">{secondRoutineExecution}</td>
                        </tr>
                        <tr>
                            <td className='w-60'><Label data={'HeaderTimeOfFlight'} /></td>
                            <td className="w-20 text-end">{firstRoutineTime}</td>
                            <td className="w-20 text-end">{secondRoutineTime}</td>
                        </tr>
                        <tr>
                            <td className='w-60'><Label data={'LabelHorizontalDisplacement'} /></td>
                            <td className="w-20 text-end">{firstRoutineHorDisplace}</td>
                            <td className="w-20 text-end">{secondRoutineHorDisplace}</td>
                        </tr>
                        {hasPenalty && <tr>
                            <td className='w-60'><Label data={'HeaderPenalties'} /></td>
                            <td className="w-20 text-end">{firstRoutinePenalty}</td>
                            <td className="w-20 text-end">{secondRoutinePenalty}</td>
                        </tr>}
                        <tr>
                            <td className='w-60'><Label data={'HeaderTotal'} sport='GTR' /></td>
                            <td className="w-20 text-end">{firstRoutine?.er_value}</td>
                            <td className="w-20 text-end">{secondRoutine?.er_value}</td>
                        </tr>
                    </tbody>
                </table >
            </>
        );
    }

    return (
        <>
            <table className="table table-detail">
                <thead>
                    <tr><th scope="col"></th>
                        <th scope="col"><Label data={'HeaderScore'} /></th>
                        <th scope="col" className="text-end"><Label data={`HeaderExercise1`} sport='GTR' /></th>
                        <th scope="col" className="text-end"><Label data={`HeaderExercise2`} sport='GTR' /></th>
                        <th scope="col"></th>
                        {showQualMark && <th scope="col"></th>}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="w-15"></td>
                        <td className={showQualMark ? 'w-35' : 'w-40'}><Label data={'HeaderDifficulty'} /></td>
                        <td className="w-15 text-end">{firstRoutineDuration}</td>
                        <td className="w-15 text-end">{secondRoutineDuration}</td>
                        <td className='w-15'></td>
                        {showQualMark && <td className='w-5'></td>}
                    </tr>
                    <tr>
                        <td className="w-15"></td>
                        <td className={showQualMark ? 'w-35' : 'w-40'}><Label data={'HeaderExecution'} /></td>
                        <td className="w-15 text-end">{firstRoutineExecution}</td>
                        <td className="w-15 text-end">{secondRoutineExecution}</td>
                        <td className="w-15"></td>
                        {showQualMark && <td className='w-5'></td>}
                    </tr>
                    <tr>
                        <td className="w-15"></td>
                        <td className={showQualMark ? 'w-35' : 'w-40'}><Label data={'HeaderTimeOfFlight'} /></td>
                        <td className="w-15 text-end">{firstRoutineTime}</td>
                        <td className="w-15 text-end">{secondRoutineTime}</td>
                        <td className="w-15"></td>
                        {showQualMark && <td className='w-5'></td>}
                    </tr>
                    <tr>
                        <td className="w-15"></td>
                        <td className={showQualMark ? 'w-35' : 'w-40'}><Label data={'LabelHorizontalDisplacement'} /></td>
                        <td className="w-15 text-end">{firstRoutineHorDisplace}</td>
                        <td className="w-15 text-end">{secondRoutineHorDisplace}</td>
                        <td className="w-15"></td>
                        {showQualMark && <td className='w-5'></td>}
                    </tr>
                    {hasPenalty && <tr>
                        <td className="w-15"></td>
                        <td className={showQualMark ? 'w-35' : 'w-40'}><Label data={'HeaderPenalties'} /></td>
                        <td className="w-15 text-end">{firstRoutinePenalty}</td>
                        <td className="w-15 text-end">{secondRoutinePenalty}</td>
                        <td className="w-15"></td>
                        {showQualMark && <td className='w-5'></td>}
                    </tr>}
                    <tr>
                        <td className="w-15"></td>
                        <td className={showQualMark ? 'w-35' : 'w-40'}><Label data={'HeaderTotal'} sport='GTR' /></td>
                        <td className="w-15 text-end">{firstRoutine?.er_value}</td>
                        <td className="w-15 text-end">{secondRoutine?.er_value}</td>
                        <td className="w-15"></td>
                        {showQualMark && <td className='w-5'></td>}
                    </tr>
                </tbody>
            </table >
        </>
    );
});

export default TableExpanded